import { useTranslation } from "react-i18next";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Applet from './Applet';
import { load as loadBusinesses } from 'store/slices/businessSlice';

const Overview = ({
  user,
  loadBusinesses,
  business
}) => {
  const {
    t
  } = useTranslation();
  // Extract the complex expression to a separate variable
  const userId = user?.objectId;
  useEffect(() => {
    // Only call loadBusinesses if user exists
    if (user && user.objectId) {
      loadBusinesses();
    }
  }, [loadBusinesses, user, userId]); // Don't render if user is not loaded yet

  if (!user || !user.objectId) {
    return <Applet title={t("My Businesses")}>
        <p>{t("No businesses created yet.")}</p>
      </Applet>;
  }

  const title = 'My Businesses';
  return <Applet title={title}>
      {business.list.length ? <>
          <p className='my-0'>{t("I have")}<strong>{business.list.length}</strong>{t("business")}{business.list.length ? 'es' : ''}{t("set up.")}<Link to='/business'>{t("Set up a business")}</Link></p>
          <ul className='pl-4'>
            {business.list.map(row => <li key={row.objectId}><Link to={`business/${row.objectId}`}>{row.name}</Link></li>)}
          </ul>
        </> : !business.loading && !business.error && <p>{t("No businesses set up.")}<Link to='/business'>{t("Set up a business")}</Link></p>}
    </Applet>;
};

const mapStateToProps = state => ({
  user: state.auth.currentUser,
  business: {
    list: state.business.list,
    error: state.business.listError,
    loading: state.business.listLoading
  }
});

const mapDispatchToProps = {
  loadBusinesses
};
export default connect(mapStateToProps, mapDispatchToProps)(Overview);